import { Container } from '@acies/core';
import Spinner from './spinner';
import theme from './theme';

export default class SpinnerOverlay extends Container {
	#spinner!: Spinner;
	private get spinner(): Spinner {
		if (!this.#spinner) {
			this.#spinner = new Spinner();
			this.#spinner.spin = true;
		}
		return this.#spinner;
	}

	public constructor() {
		super();
		this.alignment = 'center';
		this.position = 'absolute';
		this.top = 0;
		this.right = 0;
		this.bottom = 0;
		this.left = 0;
		this.fill = theme.colors.fill.white;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.spinner);
	}
}
customElements.define('ac-spinner-overlay', SpinnerOverlay);
